var $b4e14b6b8da86996$exports = {};
// ─────────────────────────────────────────────────────────────
//  Polly's People — 1940s scroll + lamp controller
// ─────────────────────────────────────────────────────────────
const $b4e14b6b8da86996$var$activeLamps = new Set();
// ── Position each lamp so its vertical centre aligns with its section's title
function $b4e14b6b8da86996$var$positionLamps() {
    const stage = document.querySelector('.lamp-stage');
    if (!stage) return;
    const stageTop = stage.getBoundingClientRect().top + window.scrollY;
    const lampHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--lamp-height')) || 520;
    document.querySelectorAll('.section[data-lamp]').forEach((section)=>{
        const lampId = section.dataset.lamp;
        if (!lampId) return;
        const lamp = document.getElementById(lampId);
        if (!lamp) return;
        // Home uses #logo; other sections use .section-header
        const title = section.querySelector('#logo, .section-header');
        if (!title) return;
        const titleRect = title.getBoundingClientRect();
        const titleTop = titleRect.top + window.scrollY - stageTop;
        const isHome = section.id === 'home';
        const offset = isHome ? titleTop + titleRect.height / 2 - lampHeight / 2 // centre-align for home
         : titleTop - lampHeight * 0.15; // top-align, shifted up 15% for other sections
        lamp.style.top = `${Math.max(0, offset)}px`;
    });
}
// ── Intersection observer — activate lamp when section scrolls into view
function $b4e14b6b8da86996$var$initLampObserver() {
    const sections = document.querySelectorAll('.section[data-lamp]');
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const lampId = entry.target.dataset.lamp;
            if (!lampId) return;
            const lamp = document.getElementById(lampId);
            if (!lamp) return;
            if (entry.isIntersecting) {
                // Re-trigger animation by briefly removing then re-adding class
                lamp.classList.remove('is-active');
                lamp.offsetWidth; // force reflow
                lamp.classList.add('is-active');
                $b4e14b6b8da86996$var$activeLamps.add(lampId);
            } else {
                lamp.classList.remove('is-active');
                $b4e14b6b8da86996$var$activeLamps.delete(lampId);
            }
        });
    }, {
        threshold: 0.35
    });
    sections.forEach((s)=>observer.observe(s));
}
function $b4e14b6b8da86996$var$buildCard(entry, zIndex) {
    const card = document.createElement('div');
    card.className = 'photo-card';
    card.style.zIndex = String(zIndex);
    // Mat (off-white border)
    const mat = document.createElement('div');
    mat.className = 'photo-card__mat';
    const img = document.createElement('img');
    img.src = entry.url;
    img.alt = entry.alt;
    img.loading = 'lazy';
    mat.appendChild(img);
    card.appendChild(mat);
    // Corner tabs (×4)
    for (const pos of [
        'tl',
        'tr',
        'bl',
        'br'
    ]){
        const corner = document.createElement('div');
        corner.className = `photo-card__corner photo-card__corner--${pos}`;
        card.appendChild(corner);
    }
    // Side rivets (×2)
    for (const side of [
        'left',
        'right'
    ]){
        const rivet = document.createElement('div');
        rivet.className = `photo-card__rivet photo-card__rivet--${side}`;
        card.appendChild(rivet);
    }
    // Name label
    const label = document.createElement('div');
    label.className = 'photo-card__label';
    label.textContent = entry.label;
    card.appendChild(label);
    return card;
}
function $b4e14b6b8da86996$var$restack(gallery) {
    const cards = Array.from(gallery.querySelectorAll('.photo-card:not(.photo-card--peeling)'));
    const total = cards.length;
    cards.forEach((card, i)=>{
        card.style.zIndex = String(total - i);
    });
}
async function $b4e14b6b8da86996$var$initDogGallery() {
    const gallery = document.getElementById('dogs-gallery');
    if (!gallery) return;
    let manifest;
    try {
        const res = await fetch('/dogs/manifest.json');
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        manifest = await res.json();
    } catch (err) {
        console.warn('Dogs gallery: could not load manifest.json', err);
        return;
    }
    const entries = manifest.map((entry)=>{
        const dateStr = entry.died ? `${entry.born} \u{2013} ${entry.died}` : `${entry.born} \u{2013}`;
        return {
            url: `/dogs/${entry.filename}`,
            dogKey: entry.name.toLowerCase(),
            alt: `${entry.name}, ${entry.breed}`,
            label: `${entry.name}  \xb7  ${dateStr}`
        };
    });
    if (entries.length === 0) return;
    // Capture as non-null for closures below
    const galleryEl = gallery;
    // Build cards — last in the array = bottom of stack (lowest z-index)
    entries.forEach((entry, i)=>{
        const card = $b4e14b6b8da86996$var$buildCard(entry, entries.length - i);
        galleryEl.appendChild(card);
    });
    // Make gallery keyboard-accessible
    galleryEl.setAttribute('tabindex', '0');
    function cycleTop() {
        const topCard = galleryEl.querySelector('.photo-card:not(.photo-card--peeling)');
        if (!topCard || galleryEl.querySelectorAll('.photo-card').length <= 1) return;
        topCard.classList.add('photo-card--peeling');
        topCard.addEventListener('animationend', ()=>{
            // Hide inline before removing the animation class so the
            // snap-back to the original transform is never visible.
            topCard.style.opacity = '0';
            topCard.classList.remove('photo-card--peeling');
            galleryEl.appendChild(topCard); // move to bottom of DOM = bottom of stack
            $b4e14b6b8da86996$var$restack(galleryEl);
            // Restore opacity in the next frame after layout has settled.
            requestAnimationFrame(()=>{
                topCard.style.opacity = '';
            });
        }, {
            once: true
        });
    }
    // Enable smooth restack transitions only after initial placement
    requestAnimationFrame(()=>galleryEl.classList.add('dogs-gallery--ready'));
    // Track last manual interaction time (0 = never, so auto-advance fires immediately)
    let lastInteractionTime = 0;
    function handleInteraction() {
        lastInteractionTime = Date.now();
        cycleTop();
    }
    galleryEl.addEventListener('click', handleInteraction);
    galleryEl.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleInteraction();
        }
    });
    // Auto-advance every 20 s, but only if no interaction in the last 60 s
    setInterval(()=>{
        if (Date.now() - lastInteractionTime >= 60000) cycleTop();
    }, 20000);
}
// ── Bootstrap
document.addEventListener('DOMContentLoaded', ()=>{
    $b4e14b6b8da86996$var$positionLamps();
    $b4e14b6b8da86996$var$initLampObserver();
    $b4e14b6b8da86996$var$initDogGallery();
    // Hydrate download links — kept out of HTML so Parcel doesn't try to bundle them
    document.querySelectorAll('a[data-download]').forEach((a)=>{
        a.href = a.dataset.download;
    });
    // Re-position once web fonts (Monoton) have finished loading — the h2
    // section headers are measured by positionLamps and their size changes
    // once the custom font renders.
    document.fonts.ready.then($b4e14b6b8da86996$var$positionLamps);
});
window.addEventListener('resize', $b4e14b6b8da86996$var$positionLamps);


//# sourceMappingURL=app.8b79d5d6.js.map
